import { Box, Button, InputAdornment, OutlinedInput, Typography } from "@mui/material";
import React, { Fragment, useState } from "react";
import TableComp from "src/components/shared/table/TableComp";
import useInventoryInBody from "./utils/useInventoryInBody";
import useAuthGlobal from "src/context/useAuthGlobal";
import useQueryParams from "src/hooks/useQueryParams";
import useResetParamsOnTabChange from "src/hooks/useResetParamsOnTabChange";
import TabComp from "src/components/shared/TabComp";
import { USER_ROLE_TYPE, WAREHOUSE_MANAGEMENT_TYPE } from "src/constant";
import SearchFilterComp from "src/components/shared/SearchFilterComp";
import InventoryStatistic from "../InventoryStaticstic";
import NamePage from "src/components/shared/NamePage";
import { Add } from "@mui/icons-material";
import useAppGlobal from "src/context/useAppGlobal";
import ImportFormDialog from "./ImportFormDialog";
import WarehouseFilter from "../components/WarehouseFilter";
import DateRangePicker from "src/components/shared/DateRangePicker";
import SelectComp from "src/components/shared/SelectComp";
import { PERMISSIONS, useRoleCheck } from "src/hooks/permission/permission";
const tabs = [
  {
    id: WAREHOUSE_MANAGEMENT_TYPE.HISTORY_IN,
    name: "Lịch sử nhập kho",
  },
  {
    id: WAREHOUSE_MANAGEMENT_TYPE.INVENTORY_IN_PENDING,
    name: "Chờ nhập kho",
  },
];
const topbarSearchList = [
  {
    id: 1,
    title: "Mã phiếu nhập",
    value: "innInCode",
  },
];

export default function InventoryInTable() {
  const permissionCheck = useRoleCheck();
  const { handleOpenDialog } = useAppGlobal();
  const { userMe } = useAuthGlobal();
  const [option] = useQueryParams();
  const [keyword, setKeyword] = useState();
  const [searchBy, setSearchBy] = useState();
  const [paramsQuery, setParamsQuery] = useState();
  const [date, setDate] = useState();
  const [value, setValue] = useState();

  useResetParamsOnTabChange(option?.tab, setParamsQuery);

  const { header, bodyList, error, isLoading, sortData, total, pagi, setPagi } = useInventoryInBody({
    topbarSearchList,
    keyword,
    searchBy,
    paramsQuery,
    date,
    warehouseId: value,
  });

  const handleImportForm = () => {
    handleOpenDialog({
      content: <ImportFormDialog />,
      size: "xl",
    });
  };

  return (
    <Fragment>
      <NamePage
        name="Quản lý Kho"
        subName="Nhập kho"
      />
      <InventoryStatistic whouseId={userMe?.currentWarehouse?._id} />

      {[USER_ROLE_TYPE.SUPER_ADMIN, USER_ROLE_TYPE.ADMIN_FACTORY].includes(userMe?.role?.code) && (
        <Box mt="12px">
          <Button
            startIcon={<Add />}
            onClick={handleImportForm}
            variant="contained"
          >
            Tạo lệnh nhập Kho
          </Button>
        </Box>
      )}

      <TabComp tabs={tabs} />

      <Box
        m="12px 0 12px"
        display="flex"
        justifyContent="space-between"
      >
        <Box
          display="flex"
          gap="6px"
          alignItems="flex-start"
        >
          <SearchFilterComp
            getSearchKeyword={setKeyword}
            getSelectKeyword={setSearchBy}
            selectList={topbarSearchList}
            placeholder="Tìm kiếm Phiếu nhập"
          />
        </Box>
        <Box
          display="flex"
          gap="12px"
        >
          {permissionCheck([PERMISSIONS.VIEW_SYSTEM_ALL, PERMISSIONS.VIEW_SYSTEM_OWN]) && (
            <Box sx={{ maxWidth: "180px" }}>
              <SelectComp
                input={
                  <OutlinedInput
                    startAdornment={
                      <InputAdornment position="start">
                        <Typography
                          fontWeight="bold"
                          sx={{
                            borderRight: "1px solid var(--grey)",
                            pr: "12px",
                            color: "var(--black)",
                            fontSize: "12px",
                          }}
                        >
                          Kho
                        </Typography>
                      </InputAdornment>
                    }
                  />
                }
                userMe={userMe}
                value={value}
                setValue={setValue}
                item={{ path: "/api/v1/warehouses", params: { limit: 100, skip: 0 } }}
              />
            </Box>
          )}
          <DateRangePicker
            value={date ?? { fromDate: null, toDate: null }}
            onApply={setDate}
            label="Thời gian Nhập Kho"
          />
          <WarehouseFilter
            variant="inventory-in"
            setParamsQuery={setParamsQuery}
            paramsQuery={paramsQuery}
          />
        </Box>
      </Box>
      <TableComp
        dynamicWidth={"800px"}
        headers={header}
        bodyList={bodyList}
        isLoading={isLoading}
        error={error}
        sortData={sortData}
        total={total}
        pagi={pagi}
        setPagi={setPagi}
      />
    </Fragment>
  );
}
